/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const RoboStrategyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={28}
    height={28}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="RoboStrategyIcon">
    <path
      d="M22.604 17.62A9.334 9.334 0 0 0 9.368 5.895L8.211 3.87a11.662 11.662 0 0 1 11.622.028c5.239 3.024 7.245 9.499 4.804 14.898l1.565.903-4.859 2.583-.192-5.5 1.453.84ZM5.396 10.38a9.334 9.334 0 0 0 13.236 11.725l1.157 2.026a11.662 11.662 0 0 1-11.622-.028C2.928 21.08.922 14.604 3.363 9.205l-1.566-.902L6.656 5.72l.192 5.5-1.453-.839v-.001Z"
      fill="var(--moreMenuIconFill)"
      stroke="var(--moreMenuIconStroke)"
      strokeWidth={0.8}
    />
    <g clipPath="url(#a)">
      <path
        d="M11.03 10.25h5.94a.416.416 0 0 1 .337.172l1.593 2.19a.208.208 0 0 1-.016.263l-4.731 5.126a.208.208 0 0 1-.294.011c-.003-.002-1.584-1.714-4.743-5.137a.208.208 0 0 1-.016-.263l1.593-2.19a.417.417 0 0 1 .337-.172Zm.213.833-1.167 1.604L14 16.938l3.924-4.25-1.167-1.604h-5.514Z"
        fill="#2894F9"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" transform="translate(9 9)" d="M0 0h10v10H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default RoboStrategyIcon;
